import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {ArticleFilters} from "../../services/ngage/articles";

export default function useGetArticles(
  criteria: ArticleFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['articles.all', criteria],
    () => ngage.articles.filtered(criteria),
    {enabled, keepPreviousData}
  );
}